<template>
  <router-link :to="`/posts/${post.id}`" class="post-card-link">
    <Card class="post-card">
      <template #header>
        <img
          v-if="post.cover"
          :src="post.cover"
          alt=""
          class="post-card-cover"
        />
        <div v-else class="post-card-cover post-card-cover-placeholder"></div>
      </template>
      <template #title>
        <h3>{{ post.title }}</h3>
        <small>{{ post.date[0] }}/{{ post.date[1] }}/{{ post.date[2] }}</small>
      </template>
      <template #content>
        <p class="post-txt">{{ post.des }}</p>
        <div class="post-card-tag">
          <b :key="i" v-for="(tag, i) in post.tags" style="margin-right: 5px">
            {{ tag }}
          </b>
        </div>
      </template>
      <template #footer>
        <div
          v-tooltip.bottom="`Posted by ${config.username}`"
          class="post-card-author"
        >
          <Avatar />
        </div>
      </template>
    </Card>
  </router-link>
</template>

<script>
import Avatar from '@/components/Avatar.vue'
import Card from 'primevue/card'
import Tooltip from 'primevue/tooltip'

export default {
  name: 'PostCard',
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  directives: {
    tooltip: Tooltip
  },
  data: function () {
    return {
      config: this.getConfig().config
    }
  },
  components: {
    Avatar,
    Card
  }
}
</script>

<style>
.post-card-link {
  text-decoration: none;
  color: inherit;
  display: block;
  width: 100%;
}

/* 卡片整体:相对定位 + flex 让 tag 锚在底部,不再用 absolute 飘出去 */
.post-card .p-card {
  height: 380px !important;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.post-card .p-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.post-card .p-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.post-card-cover {
  width: 100%;
  height: 180px;
  object-fit: cover;
}

.post-card-cover-placeholder {
  background: linear-gradient(135deg, #e0e7ff 0%, #f0f9ff 100%);
}

.post-txt {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  margin-bottom: 12px;
}

.post-card-tag {
  margin-top: auto;
  padding-top: 8px;
}

.post-card-author {
  display: inline-block;
}
</style>
